import React from "react";
import PropTypes from 'prop-types';
import { Player } from "../VideoPlayer/Player";

export default function BlogPostMediaBlock(
    {
        src,
        image,
        type,
        caption,
        attribution
    }) {

    if (type === "Video") {
        return (
            <div className="my-5 w-full">
                <Player src={src} />
                {caption ? <div className="mb-4 text-center text-plum-700 text-sm">{caption}</div> : null }
            </div>
        )
    }

    let imageSrc = src;
    if (image?.formats?.large?.url) {
        imageSrc = image.formats?.large?.url
    } else if (image?.formats?.medium?.url) {
        imageSrc = image.formats?.medium?.url
    } else if (image?.formats?.small?.url) {
        imageSrc = image.formats?.small?.url
    } else if (image?.url) {
        imageSrc = image?.url
    }

    return (
        <div className="w-full">
            <img className="mb-1 mx-auto" alt="" src={imageSrc}/>
            {caption ? <div className={`${!attribution ? 'mb-4' : ''} text-center text-plum-700 text-sm`}>{caption}</div> : null }
            {attribution ? <div className="mb-4 text-center text-plum-700 text-sm">[{attribution}]</div> : null }
        </div>
    )
}

BlogPostMediaBlock.propTypes = {
    src: PropTypes.string.isRequired,
    type: PropTypes.string
}